import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../../Accordion/Accordion.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

import data1 from "../../../Data/educationalProgram/educationalProgramDataAll.json";
import data2 from "../../../Data/educationalProgram/educationalProgramDataPlan.json";
import data3 from "../../../Data/educationalProgram/educationalProgramDataDis.json";
import data4 from "../../../Data/educationalProgram/educationalProgramDataProg.json";
import data5 from "../../../Data/educationalProgram/educationalProgramDataPric.json";

export default function EducationalProgram() {
  useSEO(seoConfig.educationalProgram);
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Образовательная программа ординатуры
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Основная профессиональная образовательная программа высшего
          образования – программа подготовки кадров высшей квалификации в
          ординатуре специальность 31.08.32 дерматовенерология
        </h3>

        <Accordion data={data1} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Учебные планы и графики:
        </h3>

        <Accordion data={data2} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Рабочие программы дисциплин:
        </h3>

        <Accordion data={data3} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Рабочие программы производственной (клинической) практики:
        </h3>

        <Accordion data={data4} />
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">Приказ:</h3>
        <Accordion data={data5} />
      </div>
    </section>
  );
}
